import Vue from 'vue'
import Rollbar from 'vue-rollbar'

export default function ({ store, isDev }) {
  const person = {
    id: store.state.user.details?.id,
    email: store.state.user.details?.email || store.state.quiz.email
  }

  if (!isDev) {
    Vue.use(Rollbar, {
      accessToken: 'cc584d571acb42708da17974e9f67395',
      captureUncaught: true,
      captureUnhandledRejections: false,
      enabled: true,
      scrubTelemetryInputs: true,
      ignoredMessages: ['script error'],
      payload: {
        environment: 'store-front_production',
        client: {
          javascript: {
            code_version: 'v1.94.12',
            source_map_enabled: true
          }
        },
        person
      }
    })
  }

  Vue.config.errorHandler = function (err, vm) {
    if (!isDev) {
      vm.$rollbar.error(err)
      throw err
    } else {
      console.log(err)
    }
  }
}
